import { SVGProps } from 'react';

const AvatarMulti = ({
  width = 28,
  height = 28,
  fill = '#FF8200',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7502 24.0466C21.2293 26.4935 17.7906 28 14 28C10.2102 28 6.77205 26.4941 4.25135 24.0481C4.25009 24.0498 4.24882 24.0515 4.24756 24.0533C3.78211 23.6012 3.34798 23.1171 2.94873 22.6044C2.94985 22.603 2.95097 22.6015 2.95209 22.6001C1.1021 20.2269 0 17.2422 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 17.2417 26.8982 20.2261 25.0487 22.5991C25.05 22.6009 25.0514 22.6026 25.0527 22.6044C24.6537 23.1168 24.2198 23.6007 23.7546 24.0526C23.7531 24.0506 23.7516 24.0486 23.7502 24.0466ZM22.5002 22.5999C20.3162 24.7587 17.314 26.0916 14.0006 26.0916C10.6875 26.0916 7.68561 24.759 5.50171 22.6006C7.68568 20.4418 10.6878 19.109 14.0013 19.109C17.3144 19.109 20.3163 20.4415 22.5002 22.5999ZM23.7506 21.1523C21.2298 18.7056 17.7912 17.1992 14.0007 17.1992C10.2102 17.1992 6.77149 18.7057 4.25067 21.1525C2.779 19.1496 1.90966 16.6767 1.90966 14.0007C1.90966 7.32303 7.32294 1.90975 14.0006 1.90975C20.6782 1.90975 26.0915 7.32303 26.0915 14.0007C26.0915 16.6766 25.2222 19.1494 23.7506 21.1523Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9998 15.2678C16.8115 15.2678 19.0908 12.9885 19.0908 10.1768C19.0908 7.36521 16.8115 5.08594 13.9998 5.08594C11.1882 5.08594 8.90894 7.36521 8.90894 10.1768C8.90894 12.9885 11.1882 15.2678 13.9998 15.2678ZM14.0004 13.3593C15.7577 13.3593 17.1822 11.9348 17.1822 10.1775C17.1822 8.42023 15.7577 6.99568 14.0004 6.99568C12.2431 6.99568 10.8186 8.42023 10.8186 10.1775C10.8186 11.9348 12.2431 13.3593 14.0004 13.3593Z"
      fill="#FFC6C9"
    />
  </svg>
);
export default AvatarMulti;
